import { useState, useEffect } from "react";
import {
  TopButton,
  SearchLocation,
  TimeAndLocation,
  TemperatureDetails,
  Forecast,
} from "./components/index";
import getFormattedWeatherData from "./Services/WeatherService";

// libraries for toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  const [query, setQuery] = useState({ q: "karachi" });
  const [units, setUnits] = useState("metric");
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const message = query.q ? query.q : "current location.";
      toast.info("Fetching Weather for " + message);
      await getFormattedWeatherData({ ...query, units }).then((data) => {
        toast.success(
          `Successfully fetched data for ${data.name} ${data.country}`
        );
        setWeather(data);
      });
    };

    fetchData();
  }, [query, units]);
  return (
    <div className="mx-auto max-w-screen-md mt-4 py-5 px-32 bg-gradient-to-br from-cyan-500 to-blue-700 h-fit shadow-2xl  shadow-cyan-300 rounded-tr-3xl rounded-bl-3xl mb-5">
      <TopButton setQuery={setQuery} />
      <SearchLocation setQuery={setQuery} units={units} setUnits={setUnits} />
      {weather && (
        <>
          <TimeAndLocation weather={weather} />
          <TemperatureDetails weather={weather} unit={units} />
          <Forecast
            title="Hourly Updates"
            items={weather.hourly}
            unit={units}
            query={query.q}
          />
          <Forecast
            title="Daily Weather Forcast"
            items={weather.daily}
            unit={units}
            query={query.q}
          />
        </>
      )}
      <ToastContainer autoClose={3000} theme="colored" newestOnTop={true} />
    </div>
  );
}

// React js color code
//color="#61DAFB"
